import React, {useRef, useState} from 'react'
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Modal, Row} from "reactstrap"
import {useSelector} from "react-redux";
import {getStateByPath} from "../../../../redux/selectors";
import * as Yup from "yup";
import {FORM, INTERNATIONAL, LB_CODE, LB_ICON, REQUIRED} from "../../../../components/i18n/i18n";
import {useForm} from "react-hook-form";
import {amenityService} from "../../../../jwt/_services/hotel/amenityService";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {roomAmenityService} from "../../../../jwt/_services/hotel/roomAmenityService";
import {GenericButton} from "../../../../components/buttons/customButtons";
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../../components/i18n/toolTips";
import {GenericTableButton} from "../../../../components/buttons/buttonsActions";
import Separator from "../../../../components/Separator";
import {PH_CODE, PH_ICON} from "../../../../components/i18n/placeHolders";
import {FL_CATEGORY, FL_TYPE_AMENITY} from "../../../../components/i18n/formLabels";
import SelectGeneric from "../../../../components/select/selectGeneric";
import {hotelCategoryProvider} from "../../../../providers/hotelCategoryProvider";
import {amenityTypeProvider} from "../../../../providers/amenityTypeProvider";
import AmenitiesLangs from "../../../hotel/suiteController/amenities/_langs";
import {LogHistoryModal} from "../../../../components/logHistory/logHistoryModal";
import LabelLangs from "../../../configuration/label/_langs";
import {labelService} from "../../../../jwt/_services/configuration/labelService";
import {pageLabelService} from "../../../../jwt/_services/landings/pageLabelService";

const LabelsForm = (props) => {
    const pageState = useSelector(state => getStateByPath(state, props.path));
    const { domainObject:page, app } = pageState?.data || {};

    const path = `${props.path}/labels`;
    const componentState = useSelector(state => getStateByPath(state, path));

    const { editMode, domainObject} = componentState?.data;

    const {fbDataBase} = app

    const [showModal, setShowModal] = useState(true)
    const [langs, setLangs] = useState(domainObject?.langs || []);
    const translatableLangs = domainObject?.translatedLangs || []

    const modalRef = useRef(null);


    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED )
    });

    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            code: domainObject?.code,
            description: domainObject?.description,
        }
    });

    const onSubmit = async (data, _) => {
        let labelRequest = {
            fbDataBase,
            item : {
                ...data,
                langs
            }
        };



        if(editMode){
            labelRequest.item.id = domainObject?.id
            await labelService.updateItem(domainObject?.id, labelRequest) // actualizar la amenidad
            return
        }

        const labelResponse = await labelService.saveItem(labelRequest) // guardar la amenidad

        const requestData = {
            fbDataBase,
            item: {
                page: { id: page?.id },
                label: { id: labelResponse?.id }
            }
        }

        genericIndexedActions.save(path, pageLabelService, requestData, closeForm) // vincular la amenidad con el tipo de habitación

    };

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }


    const closeForm = () => {
        reset();
        props.toggle()
    }


    return <Modal
        isOpen={props.isOpen}
        toggle={props.toggle}
        keyboard={false}
        modalClassName="menu-modal-form"
    >
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Card className={'card-modal'}>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-edit mr-2"/>{FORM}
                    <div className={'top-right'}>
                        <GenericButton
                            style={'table'}
                            icon={'fa-save'}
                            toolTip={TT_SAVE}
                            permission={'add'}
                            type={'submit'}
                        />
                        {
                            editMode && <>
                                <GenericTableButton
                                    toolTip={TT_HISTORY}
                                    icon={'fa-clock'}
                                    permission={'search'}
                                    onClick={showHistory}
                                />
                            </>
                        }
                        <Separator/>
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={closeForm}
                        />
                    </div>
                </CardTitle>
                <CardBody className={'card-body-modal'}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>Codigo</Label>
                                <Input type="text" name="code"
                                       placeholder=" Código"
                                       innerRef={register}
                                       className={(errors.code ? ' is-invalid' : '')}
                                />
                                { errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label>Descripción</Label>
                                <Input type="textarea"
                                       rows="3"
                                       name="description"
                                       placeholder="Ingrese una descripción"
                                       innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>{ INTERNATIONAL }
                    </CardTitle>
                    <CardBody>
                        <LabelLangs
                            langs={langs}
                            setLangs={setLangs}
                            translatableLangs={translatableLangs}
                        />
                    </CardBody>
                </CardBody>

                {
                    showModal && <LogHistoryModal
                        ref={modalRef}
                        item={domainObject}
                    />
                }
            </Card>
        </Form>
    </Modal>
}

export default LabelsForm;